module.exports = __webpack_public_path__ + "img/neera-arrow-light.766051b3.svg";